<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/gaeaRL/tc-custom/9781453200131.jpg?1706904341260" alt="This image is the cover for the book Midnight Never Comes, The Paul Chavasse Novels"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Midnight Never Comes, The Paul Chavasse Novels
      </h1>
      <p class="bookDescription body article font2">
        <b>A former intelligence operative must stop a group of ruthless Russian spies from obtaining Britain’s newest and deadliest high-tech missile.</b><br/><br/> For ten years, Paul Chavasse was one of Britain’s most promising intelligence agents. But when a botched mission in Albania destroyed him physically and psychologically, he was discharged from the agency a broken man.<br/>  <br/> To regain his life of adventure, Chavasse trains under Chinese martial arts master Yuan Tao, gathering his strength and focusing his energy. And he will tackle his deadliest assignment yet: foiling a Russian plot to steal a high-powered British missile.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jack Higgins
      </h2>
      
      <p class="authorDescription body article"><P> Jack Higgins is the <I>New York Times</I> bestselling author of more than sixty thrillers that have sold over 250 million copies worldwide, including <I>The Eagle Has Landed</I> and <I>The Wolf at the Door</I>. Before beginning his writing career, Higgins served in the British Army along the East German border. He lives in the Channel Islands. </P><P> &#160; </P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?23a6f5de